import { FlexRow } from '@/components/common/Flex';
import { Paragraph, Subheader } from '@/components/common/Typography';
import AccountLockup from '@/components/financialEntities/AccountLockup';
import GoalLockup from '@/components/goals/GoalLockup';
import { Divider } from '@chakra-ui/react';
import { getName } from '@common/financialEntities';
import { useFinancialEntitiesContext } from '@common/react/financialEntities';
import { toTitleCase } from '@common/util/strings';
import Callout from '../common/Callout';

export default function PrivacyAndSharingSection() {
    const { fes } = useFinancialEntitiesContext();
    if (!fes.unfilteredData) return <></>;

    const { goals, financialEntities } = fes.unfilteredData;
    const myGoals = goals
        .filter((g) => g.isMine && g.shareStatus !== 'PRIVATE')
        .sort((a, b) => a.name.localeCompare(b.name));
    const myAccounts = financialEntities
        .filter((a) => a.isMine && a.shareStatus !== 'PRIVATE')
        .sort((a, b) => getName(a).localeCompare(getName(b)));

    return (
        <>
            <Subheader mb={7}>Your privacy & sharing</Subheader>
            {myGoals.map((goal) => (
                <FlexRow key={goal.id} alignItems="center" mb={3}>
                    <GoalLockup
                        goal={goal}
                        flexGrow={1}
                        iconProps={{ mr: 2 }}
                        maxW="none"
                    />
                    <Paragraph>{toTitleCase(goal.shareStatus)}</Paragraph>
                </FlexRow>
            ))}

            {myGoals.length === 0 && (
                <Callout>{`You don’t have any shared goals yet`}</Callout>
            )}

            <Divider my={5} />

            {myAccounts.map((account) => (
                <FlexRow key={account.id} alignItems="center" mb={3}>
                    <AccountLockup
                        account={account}
                        showMask={false}
                        flexGrow={1}
                        iconProps={{ mr: 2 }}
                        maxW="none"
                    />
                    <Paragraph>{toTitleCase(account.shareStatus)}</Paragraph>
                </FlexRow>
            ))}

            {myAccounts.length === 0 && (
                <Callout>{`You don’t have any shared accounts yet`}</Callout>
            )}
        </>
    );
}
